import {
    CancelOrderConfirmationModalPortalProvider,
    CartItemDeleteConfirmationModalPortalProvider,
} from '@/features/pos'
import { EditAutomaticContainersModalPortalProvider } from '@/features/pos/components/Cart/parts/EditAutomaticContainersModal/contexts/Portal'
import OrderFinalization from '@/features/pos/components/OrderFinalization'
import OrderFinalizationOverlay from '@/features/pos/components/OrderFinalization/Overlay'
import EditCartItemProvider from '@/features/pos/components/OrderFinalization/contexts/EditCartItemProvider'
import OverlayProvider from '@/features/pos/components/OrderFinalization/contexts/OverlayProvider'
import { Provider as ProductConfigurationModalPortalProvider } from '@/features/pos/components/ProductConfigurationModal/contexts/Portal'
import { FC } from 'react'

const ExtendedOrderFinalization: FC = () => {
    return (
        <ProductConfigurationModalPortalProvider>
            <EditCartItemProvider>
                <CartItemDeleteConfirmationModalPortalProvider>
                    <EditAutomaticContainersModalPortalProvider>
                        <CancelOrderConfirmationModalPortalProvider>
                            <OverlayProvider>
                                <OrderFinalization />
                                <OrderFinalizationOverlay />
                            </OverlayProvider>
                        </CancelOrderConfirmationModalPortalProvider>
                    </EditAutomaticContainersModalPortalProvider>
                </CartItemDeleteConfirmationModalPortalProvider>
            </EditCartItemProvider>
        </ProductConfigurationModalPortalProvider>
    )
}

export default ExtendedOrderFinalization
